/**
 * Die zuletzt an Channex gesendeten Zeiträume eines Apartments, jüngste zuerst. Ein Paket aus dem
 * Grundkalender erscheint als eine Zeile je Zeitraum; die Vorgangs-IDs stehen an der ersten.
 */
import type { AriPushHistoryItem } from '@/shared/api';
import { PushHistoryRow } from './PushHistoryRow';

interface PushHistoryListProps {
  items: AriPushHistoryItem[];
  currency: string;
  onReapply?: ((item: AriPushHistoryItem) => void) | undefined;
}

export function PushHistoryList({ items, currency, onReapply }: PushHistoryListProps) {
  if (items.length === 0) {
    return (
      <p className="text-ink-faint text-sm">
        Noch nichts an Channex übertragen. Eine Änderung im Kalender erscheint hier, sobald sie
        gesendet ist.
      </p>
    );
  }
  return (
    <ul className="flex flex-col">
      {items.map((item, idx) => (
        <PushHistoryRow
          // Ein Paket liefert mehrere Zeilen je AuditId; der Zeitraum macht den Schlüssel eindeutig.
          key={`${item.auditId}-${item.dateFrom}-${item.dateTo}-${idx}`}
          item={item}
          currency={currency}
          onReapply={onReapply}
          isFirst={idx === 0}
        />
      ))}
    </ul>
  );
}
